import { ComponentInternalInstance, h, ref, render } from "vue";
import ConfirmationModal from "@/shared-components/common/ConfirmationModal.vue";

type ConfirmationModalProps = InstanceType<typeof ConfirmationModal>["$props"];

export function useConfirmationModal(): {
  confirm: (options: ConfirmationModalProps) => Promise<boolean>;
} {
  const modalComponent = ref<ComponentInternalInstance | null>(null);

  const showModal = (options: ConfirmationModalProps) => {
    if (!modalComponent.value) {
      const container = document.createElement("div");
      const vnode = h(ConfirmationModal, options);
      render(vnode, container);

      modalComponent.value = vnode.component;
      document.body.appendChild(container);
    }

    return modalComponent.value?.exposed?.open();
  };

  return {
    confirm: showModal,
  };
}
